import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RpxComponentsUiComponent } from './rpx-components-ui.component';
import { AlertModule } from './components/alert/alert.module';
export { AlertModule } from './components/alert/alert.module';
import { ButtonModule } from './components/button/button.module';
export { ButtonModule } from './components/button/button.module';

const RPX_MODULES = [
  AlertModule,
  ButtonModule
]

@NgModule({
  declarations: [RpxComponentsUiComponent],
  imports: [
    CommonModule,
    RPX_MODULES
  ],
  exports: [RpxComponentsUiComponent, RPX_MODULES]
})
export class RpxComponentsUiModule { }
